
import { useState, useEffect } from 'react';

const COUNTRY_SELECTION_KEY = 'country-selection';

interface CountrySelection {
  selectedCountry: string | null;
  lastUpdated: string;
}

export const useCountrySelection = (showDialogAutomatically = false) => {
  const [showDialog, setShowDialog] = useState(false);
  const [selection, setSelection] = useState<CountrySelection | null>(null);

  useEffect(() => {
    const storedSelection = localStorage.getItem(COUNTRY_SELECTION_KEY);
    if (!storedSelection && showDialogAutomatically) {
      setShowDialog(true);
    } else if (storedSelection) {
      setSelection(JSON.parse(storedSelection));
    }
  }, [showDialogAutomatically]);

  const saveSelection = (countryCode: string) => {
    const newSelection = {
      selectedCountry: countryCode,
      lastUpdated: new Date().toISOString()
    };
    localStorage.setItem(COUNTRY_SELECTION_KEY, JSON.stringify(newSelection));
    setSelection(newSelection);
    setShowDialog(false);
  };

  const resetSelection = () => {
    localStorage.removeItem(COUNTRY_SELECTION_KEY);
    setSelection(null);
    setShowDialog(showDialogAutomatically);
  };

  return {
    showDialog,
    setShowDialog,
    selection,
    saveSelection,
    resetSelection,
  };
};
